import React from 'react';
import { NotificationAlert } from '@/data/notifications';
import { NotificationRow } from './NotificationRow';

interface NotificationsListProps {
  notifications: NotificationAlert[];
}

export const NotificationsList = ({ notifications }: NotificationsListProps) => (
  <div>
    {notifications
      .sort((a, b) => {
        if (a.created_at > b.created_at) return -1;
        if (a.created_at < b.created_at) return 1;
        return 0;
      })
      .map((item, index) => (
        <NotificationRow notification={item} key={index} />
      ))}
  </div>
);
